<template>
   <v-app>
      <v-main>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="primary">
                        <v-toolbar-title>
                           <v-img alt="Vuetify Logo" class="shrink mr-2" contain src="../../src/img/eggnovo_logo.png"
                              transition="scale-transition" width="40" />
                        </v-toolbar-title>
                     </v-toolbar>
                     <div align="center">
                        <v-card-text>
                           <span class="display-1 font-weight-bold">Eggnovo</span>
                           <form ref="form" @submit.prevent="login()">
                              <v-text-field v-model="user.usuario" label="Usuario" type="text" required></v-text-field>

                              <v-text-field v-model="user.password" label="Contraseña" type="password" autocomplete="on"
                                 required></v-text-field>
                              <v-btn type="submit" class="mt-4" color="primary">Login</v-btn>
                              <div v-if="mensaje != ''">
                                 <br>
                                 <p class="red--text">{{mensaje}}</p>
                              </div>
                           </form>
                        </v-card-text>
                     </div>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-main>
   </v-app>
</template>

<script>
   import {mapActions } from 'vuex'
export default {

   name: "Login",
   data() {
      return {
         user: { usuario: '', password: '' ,id_rol: ''},
         mensaje: "",
      };
   },
   methods: {  
      ...mapActions(["postDataWithReturn"]),
      ...mapActions("eggnovo",['set_usuarioLogeado']),
      //   ...mapActions(['guardarUsuario']),
      login() {
         // this.axios.post('/login', this.user)
         const payload = {
            path: 'login/login',
            body: this.user
         }
         this.postDataWithReturn(payload)
         .then(res => {
            localStorage.setItem('token', res.token)
            localStorage.setItem('id_rol', res.usuario.id_rol)
            localStorage.setItem('id_usuario', res.usuario.id)
            this.$router.push({ name: 'Principal' })
            this.set_usuarioLogeado({usuario: this.user.usuario})
         })
         .catch(e => {
            this.mensaje = e.response.message
         })
      },
   },
};
</script>